<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h720_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item
                    label="订单类型"
                    required
                  >
                    <el-radio-group v-model="dialogAddEditForm.type">
                      <el-radio :label="1">
                        委托制作
                      </el-radio>
                      <el-radio :label="2">
                        购买
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogAddEditForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="供应商"
                    prop="supplierId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.supplierId"
                      filterable
                      clearable
                      placeholder="请选择供应商"
                      style="width:100%"
                      @change="changeSupplierFun"
                    >
                      <el-option
                        v-for="item in supplierOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.cityName }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="订单日期"
                    prop="orderDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.orderDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单总金额">
                    <el-input
                      v-model="mathOrderTotal"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="预计制作完成日期">
                    <el-date-picker
                      v-model="dialogAddEditForm.estimatedCompleteDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="实际制作完成日期">
                    <el-date-picker
                      v-model="dialogAddEditForm.completeDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="经办人"
                    prop="managerId"
                  >
                    <el-select
                      v-model="dialogAddEditForm.managerId"
                      filterable
                      clearable
                      placeholder="请选择经办人"
                      style="width:100%"
                      @change="changeManagerFun"
                    >
                      <el-option
                        v-for="item in managerOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                        <span style="float: left">{{ item.label }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.info }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="8">
                  <el-form-item label="物料制作费用">
                    <el-input
                      v-model="mathMakeTotal"
                      disabled
                    >
                      <template slot="append">
                        元
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="其他费用">
                    <el-input
                      v-model="dialogAddEditForm.otherAmount"
                      @input="(val)=>{limitNumber(val, dialogAddEditForm, 'otherAmount')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditForm, 'otherAmount', 2)"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="其他费用说明"
                    prop="otherReason"
                  >
                    <el-input v-model="dialogAddEditForm.otherReason" />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="modal-box">
            <h3 class="modal-title">
              物料信息
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="materialsTableData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      label="需求明细"
                      type="expand"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-table
                          :data="scope.row.demandDetailList"
                          style="width: 100%"
                          :header-cell-style="{background:'#00d9ff'}"
                          border
                        >
                          <el-table-column
                            type="index"
                            label="序号"
                            width="60"
                          />
                          <el-table-column
                            prop="provinceName"
                            label="省区"
                            width="70"
                          />
                          <el-table-column
                            prop="cityName"
                            label="市场"
                            show-overflow-tooltip
                            width="100"
                          />
                          <el-table-column
                            prop="schemeContent"
                            label="需求来源"
                            width="200"
                            show-overflow-tooltip
                          />
                          <el-table-column
                            prop="materialsName"
                            label="需求物料"
                            show-overflow-tooltip
                            width="180"
                          />
                          <el-table-column
                            prop="auditMakeNumber"
                            label="需求数量"
                            width="100"
                          />
                          <el-table-column
                            prop="demandSide"
                            label="需求方"
                            width="100"
                            show-overflow-tooltip
                          />
                          <el-table-column
                            prop="receiver"
                            label="收货人"
                            width="100"
                          />
                          <el-table-column
                            prop="receivePhone"
                            label="联系电话"
                            width="120"
                          />
                          <el-table-column
                            prop="receiveAddress"
                            label="收货地址"
                            show-overflow-tooltip
                            width="200"
                          />
                        </el-table>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="materialsName"
                      label="物料名称"
                    />
                    <el-table-column
                      prop="materialsSpecification"
                      label="物料规格"
                      width="100"
                    />
                    <el-table-column
                      prop="materialsUnit"
                      label="物料单位"
                      width="90"
                    />
                    <el-table-column
                      label="制作单价(元)"
                      width="150"
                    >
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.makePrice"
                          @input="(val)=>{computedMathRow(val, scope.row, 'makePrice')}"
                          @blur="setMaterialsPriceValue($event, scope.row, 'makePrice')"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="makeNumber"
                      label="数量"
                      width="120"
                    />
                    <el-table-column
                      label="金额"
                      width="120"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.makeAmount }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box pic-container">
            <h3 class="modal-title">
              照片信息<span style="padding-left:30px;color:red">上传图片大小：小于10M; 格式：png、jpg、jpeg、gif</span>
            </h3>
            <div class="modal-row-box">
              <el-upload
                ref="picUpload"
                list-type="picture-card"
                :action="picUploadAction"
                :data="picData"
                :before-upload="beforeAvatarUpload"
                :file-list="initFileList"
                :on-preview="handlePictureCardPreview"
                :headers="{'X-Token': getToken()}"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                :with-credentials="true"
                :on-success="function (res, file, fileList) {return handleSuccess (res, file, fileList, picList)}"
                :on-remove="(file,fileList)=>handlePictureCardRemove(file,fileList,picList)"
              >
                <el-button
                  type="success"
                  class="upload-button"
                  icon="el-icon-folder-opened"
                >
                  选择图片
                </el-button>
              </el-upload>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          :disabled="operateButtonDisable"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
      <el-dialog
        :visible.sync="dialogImageVisible"
        append-to-body
      >
        <img
          width="100%"
          :src="dialogImageUrl"
          alt=""
        >
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 数据请求
import { getUserId, getToken } from '@/utils/auth'
import { findAttachmentInfoByConditionApi, deleteFileApi } from '@/api/common'
import { loadUserAreaSelectDataApi } from '@/api/user'
import { initCommissionedOrderApi, saveCommissionedOrderApi } from '@/api/materialsCommissionedOrder'
import { getSettleUnitListApi } from '@/api/settleUnit'

export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: null
    },
    sendArray: {
      type: Array,
      default: null
    },
    supplier: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',

      dialogAddEditForm: {},
      dialogAddEditFormRules: {
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择城市', trigger: 'change' }],
        supplierId: [{ required: true, message: '请选择供应商', trigger: 'change' }],
        orderDate: [{ required: true, message: '请选择订单日期', trigger: 'blur' }],
        managerId: [{ required: true, message: '请选择经办人', trigger: 'change' }],
        otherReason: [{ max: 255, message: '其他费用说明最多输入255个字符', trigger: 'blur' }],
        remark: [{ max: 1024, message: '备注最多输入1024个字符', trigger: 'blur' }]
      },
      // 委托制作物料明细
      materialsTableData: [],
      supplierOptions: [],
      managerOptions: [],
      //上传相关
      picData: { directory: 'commissionedOrder' },
      picUploadAction: '',
      initFileList: [],
      dialogImageUrl: '',
      dialogImageVisible: false,
      picList: [], // 照片对象数组
      baseUrl: ''
    }
  },
  computed: {
    // 计算物料制作费用总金额
    mathMakeTotal() {
      return this.materialsTableData.reduce((prev, item) => {
        return this.formatNumber(prev + Number(item.makeAmount), 2)
      }, 0)
    },
    // 计算订单总金额
    mathOrderTotal() {
      let total = Number(this.mathMakeTotal) + Number(this.dialogAddEditForm.otherAmount)
      return total
    },
    // 计算物料制作数量
    mathMakeNumber() {
      return this.materialsTableData.reduce((prev, item) => {
        return this.formatNumber(prev + Number(item.makeNumber), 2)
      }, 0)
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.operateButtonDisable = false

        this.baseUrl = process.env.VUE_APP_BASE_API
        this.picUploadAction = process.env.VUE_APP_BASE_API + '/web/common/uploadFile'
        this.picList = []
        this.initFileList = []

        this.dialogAddEditForm = {
          type: 1,
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          supplier: 0, // 供应方
          supplierId: '',
          supplierName: '',
          orderDate: '',
          estimatedCompleteDate: '',
          completeDate: '',
          makeNumber: 0,
          orderAmount: 0,
          makeAmount: 0,
          otherAmount: 0,
          otherReason: '',
          managerId: '',
          manager: '',
          remark: '',
          makeMaterials: '',
          orderDetails: '', // 制作物料明细JSON字符串
          demandDetailIds: '' // 生成物料委托制造单的物流需求申请ID字符串
        }
        this.materialsTableData = []
        this.supplierOptions = []
        this.managerOptions = []

        // 获取供应商选项数据
        this.initSupplierSelectData()
        // 获取经办人选项数据
        this.initManagerSelectData()
        if (this.eventType !== 'add') {
          this.initData()
        } else {
          this.initAddData()
        }

        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
      }
    }
  },
  methods: {
    getToken,
    // 初始化新增数据
    initAddData() {
      this.dialogAddEditForm.supplier = this.supplier
      // 把相同物料的需求合并成一个
      let demandDetailIds = ''
      let materialsMap = new Map()
      this.sendArray.forEach(item => {
        let materialsId = item.materialsId
        let materialsObject = {}
        let materialDemandIds = ''
        let makeNumber = Number(item.auditMakeNumber)
        let demandDetailList = []
        if (materialsMap.get(materialsId)) {
          materialsObject = materialsMap.get(materialsId)
          makeNumber = makeNumber + Number(materialsObject.makeNumber)
          materialDemandIds = materialsObject.demandDetailIds + ',' + item.id
          demandDetailList = materialsObject.demandDetailList
        } else {
          materialsObject.materialsId = materialsId
          materialsObject.materialsName = item.materialsName
          materialsObject.materialsUnit = item.materialsUnitName
          materialsObject.materialsSpecification = item.materialsSpecification
          materialsObject.makePrice = 0
          materialsObject.makeAmount = 0
          materialDemandIds = item.id
        }
        materialsObject.makeNumber = makeNumber
        materialsObject.demandDetailIds = materialDemandIds
        demandDetailList.push(item)
        materialsObject.demandDetailList = demandDetailList

        materialsMap.set(materialsId, materialsObject)
        demandDetailIds = demandDetailIds + ',' + item.id
      })
      this.dialogAddEditForm.demandDetailIds = demandDetailIds.substring(1)

      let tableData = []
      materialsMap.forEach(function (value) {
        tableData.push(Object(value))
      })
      this.materialsTableData = tableData
      this.loading = false
    },
    // 加载数据
    initData() {
      initCommissionedOrderApi({ id: this.dataId, operate: 'edit' }).then(response => {
        const { data } = response
        let orderData = data.materialsCommissionedOrder
        for (let key in this.dialogAddEditForm) {
          if (key.endsWith('Date')) this.dialogAddEditForm[key] = orderData[key + 'Value']
          else this.dialogAddEditForm[key] = orderData[key]
        }
        this.dialogAddEditForm.id = orderData.id
        this.materialsTableData = data.orderDetailList
        findAttachmentInfoByConditionApi({ sourceType: 18, sourceId: orderData.id }).then(res1 => {
          if (res1.data && res1.data.length > 0) {
            res1.data.forEach(item => {
              let obj = {}
              obj.name = item.attachmentName
              obj.url = this.baseUrl + item.attachmentUrl
              obj.attachmentName = item.attachmentName
              obj.attachmentUrl = item.attachmentUrl
              if (item.attachmentUrl.indexOf('activityDispatchSignInfo') === -1) {
                this.picList.push(obj)
                this.initFileList.push(obj)
              }
            })
          }
        })
        this.loading = false
      })
    },
    // 初始供应商下拉数据
    initSupplierSelectData() {
      getSettleUnitListApi({ status: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.supplierOptions.push({ label: item.unitName, data: item.id, provinceId: item.provinceId, provinceName: item.provinceName, cityId: item.cityId, cityName: item.cityName })
        })
      })
    },
    // 选择供应商回调
    changeSupplierFun(val) {
      let selectItem = {}
      selectItem = this.supplierOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditForm.supplierName = selectItem ? selectItem.label : ''
      this.dialogAddEditForm.provinceId = selectItem ? selectItem.provinceId : 0
      this.dialogAddEditForm.provinceName = selectItem ? selectItem.provinceName : ''
      this.dialogAddEditForm.cityId = selectItem ? selectItem.cityId : 0
      this.dialogAddEditForm.cityName = selectItem ? selectItem.cityName : ''
    },
    // 初始化经办人下列数据
    initManagerSelectData() {
      loadUserAreaSelectDataApi({ sorts: '1' }).then(response => {
        const { data } = response
        data.forEach(item => {
          this.managerOptions.push({ value: item.value, label: item.label, info: item.provinceNames })
        })
        if (this.eventType === 'add') {
          this.dialogAddEditForm.managerId = Number(getUserId())
          this.changeManagerFun(this.dialogAddEditForm.managerId)
        }
      })
    },
    // 经办人选择回调
    changeManagerFun(val) {
      let selectItem = {}
      selectItem = this.managerOptions.find(item => {
        return item.value === val
      })
      this.dialogAddEditForm.manager = selectItem ? selectItem.label : ''
    },
    // 计算每一项物料制作金额
    computedMathRow(val, obj, name) {
      this.limitPositiveNumber(val, obj, name)
      this.setNumberZero(obj, name)
      obj['makeAmount'] = this.formatNumber(Number(obj['makePrice']) * Number(obj['makeNumber']), 2)
    },
    // 物料明细单价输入框失去焦点响应事件
    setMaterialsPriceValue(event, obj, name) {
      this.setNumberValueDefaultZero(event, obj, name, 2)
      obj['makeAmount'] = this.formatNumber(Number(obj['makePrice']) * Number(obj['makeNumber']), 2)
    },
    // 图片上传前
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 10
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过10MB!')
        return false
      }
      this.isUploading = true
    },
    // 预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogImageVisible = true
    },
    // 上传成功
    handleSuccess(res, file, fileList, dataObj) {
      if (res.mark === '200') {
        let fileObj = {}
        fileObj.attachmentName = res.myFileName
        fileObj.attachmentUrl = res.fileName
        fileObj.url = this.baseUrl + res.fileName
        dataObj.push(fileObj)
        this.isUploading = false
      } else {
        this.$message.error(res.message)
      }
    },
    // 删除
    handlePictureCardRemove(file, fileList, dataObj) {
      let fileUrl = ''
      if (file.response) {
        let resData = file.response
        let delIndex = dataObj.findIndex(item => {
          return item.attachmentUrl === resData.fileName
        })
        fileUrl = resData.fileName
        dataObj.splice(delIndex, 1)
      } else {
        let delIndex = dataObj.findIndex(item => {
          if (item.url === file.url) {
            fileUrl = item.attachmentUrl
            return item.url === file.url
          }
        })
        dataObj.splice(delIndex, 1)
      }
      if (fileUrl !== '') {
        deleteFileApi({ filePath: fileUrl }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
          }
        })
      }
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '物料委托制作单', '系统提示',
            { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
          )
            .then(async () => {
              this.operateButtonDisable = true
              this.loading = true
              this.loadingText = '正在处理数据中，请耐心等待'

              this.dialogAddEditForm.makeAmount = Number(this.mathMakeTotal)
              this.dialogAddEditForm.orderAmount = Number(this.mathOrderTotal)
              this.dialogAddEditForm.makeNumber = Number(this.mathMakeNumber)
              let makeMaterials = ''
              this.materialsTableData.forEach(item => {
                makeMaterials = makeMaterials + ',' + item.materialsName + '(' + item.makeNumber + ')'
              })
              this.dialogAddEditForm.makeMaterials = makeMaterials.substring(1)
              this.dialogAddEditForm.orderDetails = JSON.stringify(this.materialsTableData)
              let picUrls = []
              let picNames = []
              this.picList.forEach(item => {
                picUrls.push(item.attachmentUrl)
                picNames.push(item.attachmentName)
              })
              this.dialogAddEditForm.picUrls = JSON.stringify(picUrls)
              this.dialogAddEditForm.picNames = JSON.stringify(picNames)

              saveCommissionedOrderApi(this.dialogAddEditForm).then(res => {
                if (res.mark === '200') {
                  this.$message({ message: res.message, type: 'success' })
                  this.reloadData()
                  this.modalClose()
                }
              }).catch(() => {
                this.loading = false
                this.operateButtonDisable = false
              })
            })
            .catch(() => { })
        }
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
  .cell {
    line-height: 16px;
  }
}
.pic-container {
  position: relative;
  .pic-name {
    display: inline-block;
    padding-top: 7px;
    margin-bottom: 10px;
  }
  .upload-button {
    position: absolute;
    top: 0;
    right: 0px;
  }
  ::v-deep .el-upload--picture-card i {
    font-size: 14px !important;
    color: #fff !important;
  }
  ::v-deep .el-upload--picture-card {
    border: none;
    height: 0px;
    overflow: hidden;
  }
}
::v-deep .el-upload-list--picture-card {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .el-upload-list__item {
    display: flex;
    flex: 0 0 218px;
    margin-right: 8px;
    width: 218px;
    height: 218px;
    align-items: center;
    border-radius: 0;
  }
  .el-upload-list__item-thumbnail {
    height: auto;
    align-items: center;
  }
}
</style>
